// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const foundationStatisticsQuery = gql`
  query foundationStatistics($id: ID!) {
    foundationStatistics(id: $id) {
      community {
        issues {
          count
          percentage
        }
        commits {
          count
          percentage
        }
        contributors {
          count
          percentage
        }
        merges {
          count
          percentage
        }
      }

      repositorySecurity {
        name
        high
        low
        medium
      }

      organizationsRepositoryDetails {
        issues {
          count
          percentage
        }
        commits {
          count
          percentage
        }
        contributors {
          count
          percentage
        }
        merges {
          count
          percentage
        }
      }
      activeContributors {
        name
        avatarUrl
        commits
      }
    }
  }
`;
